import React from "react";
import { Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PLATFORM_META } from "./version-gate-platform-card";

/**
 * Dải tóm tắt cạnh tiêu đề trang: nhìn 1 giây biết đang ép bản nào cho từng nền
 * tảng, không phải mở tab và đọc 2 ô input.
 *
 * Đọc giá trị ĐANG GÕ trong form (không phải bản đã lưu) nên vừa sửa là đổi ngay —
 * cố ý, để admin thấy hậu quả trước khi bấm Lưu.
 */
export default function VersionGateHeaderSummary({ values, platformKeys }) {
    return (
        <div className="flex flex-wrap gap-2">
            {platformKeys.map((key) => {
                const g = values?.[key] || {};
                const meta = PLATFORM_META[key];
                const off = g.enabled === false;
                return (
                    <Tag key={key} color={off ? "default" : "red"} className="m-0">
                        <FontAwesomeIcon icon={meta.icon} className="mr-1.5" />
                        {meta.label}: {off ? "không nhắc" : `ép ≥ ${g.minVersion || "—"}`}
                    </Tag>
                );
            })}
        </div>
    );
}
